import { render } from "./NotFound.vue?vue&type=template&id=01c5f242&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=01c5f242&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-01c5f242"

export default script